export default __webpack_public_path__ + "48b4dc092fe08cb69d6ceae6fd19bb7a.svg";